import {ITagline, IDocument, ProductLine} from "./interfaces";

export function taglinesForDocument(taglines: ITagline[], document?: IDocument): ITagline[] {
	if (document == undefined || document.coverImage == null) {
		return [];
	}
	switch (document.coverImage.coverType) {
		case ProductLine.LOVELAND:
			return taglines.filter(t => t.productLine == ProductLine.LOVELAND);
		case ProductLine.SEED:
			return taglines.filter(t => t.productLine == ProductLine.SEED);
		case ProductLine.ALL:
			return taglines;
	}
	return [];
}



// WEBPACK FOOTER //
// ./src/infrastructure/Taglines.ts